import NavLinks from "./NavLinks";
import './Navbar.css';
import {MdOutlineMenu} from 'react-icons/md';
import { useState } from "react";

import {MdClose} from 'react-icons/md';

const MobileNavigation = () =>{

    
    const Hamburger = <MdOutlineMenu className="HamburgerMenu" size="30px" color="white" onClick={() => setClick(!click)} />

    const Close = <MdClose className="HamburgerMenu" size="30px" color="white" onClick={() => setClick(!click)} />

    const [click, setClick] = useState(false);
    const closeMenu = () => setClick(false);

    return(
        <nav className="MobileNavigation">
             { click ? Close : Hamburger}
             {click && <NavLinks isClicked={true} closeMenu={closeMenu}/>}
        </nav>
    )
}

export default MobileNavigation;